
export class ActionNotification {
  public notificationID: number;
  public customerID: number;
  public title: string;
  public notificationDetail: string;
  public isActive: boolean;
  public sortOrder: number;
  public createdDate: Date;

}



// WEBPACK FOOTER //
// ./src/app/models/notification/action-notification.model.ts